var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(-0.018 -0.011)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 76.5,
    cy: 76.5,
    r: 76.5,
    transform: "translate(0.018 0.011)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M31.829,6.25A25.583,25.583,0,0,0,6.25,31.829V72.752A25.583,25.583,0,0,0,31.829,98.331H72.752A25.583,25.583,0,0,0,98.331,72.752V31.829A25.583,25.583,0,0,0,72.752,6.25ZM82.984,16.482A5.115,5.115,0,1,1,77.869,21.6,5.116,5.116,0,0,1,82.984,16.482ZM52.291,26.712A25.579,25.579,0,1,1,26.712,52.291,25.583,25.583,0,0,1,52.291,26.712Zm0,10.232A15.347,15.347,0,1,0,67.637,52.291,15.346,15.346,0,0,0,52.291,36.944Z",
    transform: "translate(24.173 24.393)",
    fill: "#273c49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramWhite);
export default __webpack_public_path__ + "static/media/instagram-white.00a23c72faab017e149a3c25f0c90c15.svg";
export { ForwardRef as ReactComponent };